package com.speedsoftware.nibbler

interface Platform {
    val name: String
}

expect fun getPlatform(): Platform

expect fun getDefaultServerUrl(): String

expect fun getInitialUrlToken(): String?

/** Returns a password-reset token from the URL (web: `?reset=...`), or null on other platforms. */
expect fun getInitialResetToken(): String?

/**
 * True when [serverUrl] is the very origin the app was loaded from (web only). Then the browser keeps the
 * session in an HttpOnly cookie and the app never has to hold a token; everywhere else the app uses a token.
 */
expect fun isSameOriginServer(serverUrl: String): Boolean

/** True on the native phone apps (Android, iOS), which get the long, sliding session. */
expect fun isMobileApp(): Boolean


/** Remembers the user's theme choice ("SYSTEM", "DARK" or "LIGHT") between visits where the platform allows it. */
expect fun loadStoredThemeMode(): String?

expect fun storeThemeMode(mode: String)

/** Whether the operating system / browser currently prefers a dark appearance. */
expect fun systemPrefersDarkTheme(): Boolean


/** A login kept between app launches: the session token and the server it belongs to. */
data class StoredSession(val token: String, val serverUrl: String)

/** Returns the remembered login, or null where the platform keeps none (the web uses cookie sessions). */
expect fun loadStoredSession(): StoredSession?

/** Remembers [session], or forgets the stored one when null. */
expect fun storeSession(session: StoredSession?)
